import { useLayoutEffect, useRef, useState } from 'react';
import { getVisibleQualificationCount } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/components/RotationsplanCard/getVisibleQualificationCount';
import { useIsMobile } from '@/hooks/useIsMobile';

export function useVisibleQualificationCount(qualificationNames: string[]) {
  const isMobile = useIsMobile();
  const measurementRef = useRef<HTMLDivElement>(null);
  const [visibleCount, setVisibleCount] = useState(0);

  useLayoutEffect(() => {
    if (isMobile) return;
    const measurement = measurementRef.current;
    if (!measurement) return;

    const children = Array.from(measurement.children) as HTMLElement[];
    const remainingBadge = children[children.length - 1];
    const nameBadges = children.slice(0, -1);
    const updateVisibleCount = () => {
      const width = measurement.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(measurement).columnGap);
      const badgeWidths = nameBadges.map(
        (badge) => badge.getBoundingClientRect().width,
      );

      setVisibleCount(
        getVisibleQualificationCount(badgeWidths, width, gap, (count) => {
          remainingBadge.textContent = `+${count}`;
          return remainingBadge.getBoundingClientRect().width;
        }),
      );
    };

    updateVisibleCount();
    const observer = new ResizeObserver(updateVisibleCount);
    observer.observe(measurement);
    nameBadges.forEach((badge) => observer.observe(badge));
    return () => observer.disconnect();
  }, [isMobile, qualificationNames]);

  return {
    measurementRef,
    visibleCount: isMobile ? qualificationNames.length : visibleCount,
  };
}
